import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { PHONE_TEL, PHONE_SHORT, WHATSAPP_URL } from "@/data/site";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";

export const Footer = () => (
  <footer className="border-t border-[#1E293B] bg-[#080C14]" data-testid="footer">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="flex flex-col items-start justify-between gap-10 py-12 md:flex-row md:items-center">
        <Link to="/" data-testid="footer-logo">
          <img src="/assets/logo.png" alt="SMS Electrical & Fiber Optic Installers" className="h-20 w-auto" />
        </Link>

        <div className="flex items-center gap-4 md:border-l md:border-[#1E293B] md:pl-10">
          <Phone className="h-10 w-10 text-[#FF5B00]" strokeWidth={1.6} />
          <div>
            <p className="font-mono-tech text-[11px] font-semibold uppercase tracking-[0.25em] text-[#FF5B00]">Get In Touch</p>
            <a
              href={PHONE_TEL}
              data-testid="footer-phone"
              className="font-display text-3xl font-bold tracking-wide text-[#F8FAFC] transition-colors duration-300 hover:text-[#FF5B00]"
            >
              {PHONE_SHORT}
            </a>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp"
              className="mt-0.5 flex items-center gap-2 text-sm text-[#94A3B8] transition-colors duration-300 hover:text-[#25D366]"
            >
              <WhatsAppIcon className="h-3.5 w-3.5 text-[#25D366]" />
              Call or WhatsApp
            </a>
          </div>
        </div>

        <div>
          <Link
            to="/contact"
            data-testid="footer-contact-button"
            className="group flex items-center gap-3 bg-[#FF5B00] px-8 py-4 font-mono-tech text-sm font-semibold tracking-[0.12em] text-white transition-colors duration-300 hover:bg-[#E05000]"
          >
            <WhatsAppIcon className="h-5 w-5" />
            Contact Us
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
          <p className="mt-3 text-sm italic text-[#94A3B8]" data-testid="footer-tagline">Let&apos;s Power Your Next Project.</p>
        </div>
      </div>

      <div className="flex flex-col items-start justify-between gap-4 border-t border-[#1E293B] py-6 md:flex-row md:items-center">
        <p className="font-mono-tech text-[11px] tracking-[0.08em] text-[#64748B]" data-testid="footer-copy">
          © {new Date().getFullYear()} SMS Electrical &amp; Fiber Optic Installers. All Rights Reserved.
        </p>
        <nav className="flex items-center gap-6" data-testid="footer-nav">
          <Link to="/" className="font-mono-tech text-[11px] uppercase tracking-[0.2em] text-[#94A3B8] transition-colors duration-300 hover:text-[#FF5B00]" data-testid="footer-link-home">Home</Link>
          <Link to="/contact" className="font-mono-tech text-[11px] uppercase tracking-[0.2em] text-[#94A3B8] transition-colors duration-300 hover:text-[#FF5B00]" data-testid="footer-link-contact">Contact</Link>
        </nav>
        <p className="font-mono-tech text-[11px] uppercase tracking-[0.2em] text-[#64748B]" data-testid="footer-services">
          Residential&nbsp;|&nbsp;Commercial&nbsp;|&nbsp;Industrial&nbsp;|&nbsp;Fiber Optic
        </p>
      </div>
    </div>
  </footer>
);
